<template>

		<div>

			<div class="edit-translations">
				<div class="toolbar">
					<nav class="subnav">
						<ul>
							<li>
								<h3>Translations</h3>
							</li>
							<li>
								<LangSwitch type="multiple" ref="langswitch"></LangSwitch>
							</li>
						</ul>
					</nav>

				</div>

				<!-- SPECIFIC -->
				<a href="#" class="btn-group active" data-tab-btn="translations-specific" data-tab-group="translations"><i class="fa fa-plus"></i> Template specific</a>
				<div class="group" data-tab-body="translations-specific" data-tab-group="translations" style="display: block;">

					<form id="multilanguage" action="#">

						<div class="languages">

							<div class="lang" v-for="lang in data.languages" :key="lang.locale" :class="lang.locale">
								<h3>{{lang.language}}</h3>
							</div>
							<div class="lang small"></div>

								<template v-for="frag in fragments">
									<hr :key="frag.id">

									<template v-if="frag[Object.keys(frag)[0]].templates.length === 1">
										<template v-for="lang in data.languages">
											<div class="lang" :key="frag[lang.locale].uuid + lang.locale" :class="lang.locale">
												<label>{{frag[lang.locale].data.name.value}}</label>
												<textarea
													class="redactor-content"
													:name="frag[lang.locale].data.name.value"
													:data-uuid="frag[lang.locale].uuid"
													:data-lang="frag[lang.locale].market.locale"
													:data-config="frag[lang.locale].settings.editoroptions.value"
													:value="frag[lang.locale].data.translation.value"
													required
													pattern="[a-z]+">
												</textarea>
											</div>
										</template>

										<div v-if="permissions.delete" class="lang small" :key="frag[Object.keys(frag)[0]].uuid">
											<a href="#" class="btn-delete-confirm fa fa-trash-alt nobubble" :key="frag.id" :data-uuid="frag[Object.keys(frag)[0]].uuid" @click="deleteTranslatationClickHandler"></a>
										</div>
									</template>

								</template>

						</div>

					</form>
				</div>

				<!-- GLOBAL -->
				<a href="#" class="btn-group" data-tab-btn="translations-global" data-tab-group="translations"><i class="fa fa-plus"></i> Global</a>
				<div class="group" data-tab-body="translations-global" data-tab-group="translations">

					<form id="multilanguage" action="#">

						<div class="languages">

							<div class="lang" v-for="lang in data.languages" :key="lang.locale" :class="lang.locale">
								<h3>{{lang.language}}</h3>
							</div>
							<div class="lang small"></div>

								<template v-for="frag in fragments">
									<hr :key="frag.id">

									<template v-if="frag[Object.keys(frag)[0]].templates.length > 1">
										<template v-for="lang in data.languages">
											<div class="lang" :key="frag[lang.locale].uuid + lang.locale" :class="lang.locale">
												<label>{{frag[lang.locale].data.name.value}}</label>
												<textarea
													class="redactor-content"
													:name="frag[lang.locale].data.name.value"
													:data-uuid="frag[lang.locale].uuid"
													:data-lang="frag[lang.locale].market.locale"
													:data-config="frag[lang.locale].settings.editoroptions.value"
													:value="frag[lang.locale].data.translation.value"
													required
													pattern="[a-z]+">
												</textarea>
											</div>
										</template>

										<div v-if="permissions.delete" class="lang small" :key="frag[Object.keys(frag)[0]].uuid">
											<a href="#" class="btn-delete-confirm fa fa-trash-alt nobubble" :key="frag.id" :data-uuid="frag[Object.keys(frag)[0]].uuid" @click="deleteTranslatationClickHandler"></a>
										</div>
									</template>
								</template>

						</div>

					</form>
				</div>

			</div>

			<div class="add-translations hidden">
				<h3>Add translation</h3>

				<form id="add-translation">
					<ul class="form">
						<li>
							<input type="text" name="name" placeholder="Name" v-model="machineName" @input="machineNameChangeHandler" required pattern="[a-z]+">
						</li>
						<li>
							<ul class="options colums2">
								<li>
									<label class="flex-label">
										<input type="checkbox" name="options" value="formatting">Headings
									</label>
								</li>
								<li>
									<label class="flex-label">
										<input type="checkbox" name="options" value="bold">Bold
									</label>
								</li>
								<li>
									<label class="flex-label">
										<input type="checkbox" name="options" value="italic">Italic
									</label>
								</li>
								<li>
									<label class="flex-label">
										<input type="checkbox" name="options" value="underline">Underline
									</label>
								</li>
								<li>
									<label class="flex-label">
										<input type="checkbox" name="options" value="link">Links
									</label>
								</li>
								<li>
									<label class="flex-label">
										<input type="checkbox" name="options" value="lists">Lists
									</label>
								</li>
								<li>
									<label class="flex-label">
										<input type="checkbox" name="options" value="image">Images
									</label>
								</li>
								<li>
									<label class="flex-label">
										<input type="checkbox" name="options" value="video">Video
									</label>
								</li>
								<li>
									<label class="flex-label">
										<input type="checkbox" name="options" value="html">HTML
									</label>
								</li>
							</ul>
						</li>
					</ul>
				</form>
			</div>

		</div>

</template>

<script>

import LangSwitch from '../../components/LangSwitch.vue'
import xhrModule from '../../modules/xhrModule.js'
import cms from '../../modules/cms.js'
import general from '../../modules/general.js'
import validation from '../../modules/forms/validation.js'
import redactorConfig from '../../modules/forms/redactorConfig.js'

export default {
	name: 'translation-sidebar',
	props: {
		data: Object
	},

	components: {
		'LangSwitch': LangSwitch
	},

	data () {
		return {
			entityID: 27,
			overlayHidden: true,
			machineName: null,
			translationsForm: null,
			posting: false,
			fragments: null,
			changedFieldsArr: [],
			redactorFields: [],
			roles: this.$store.state.user.roles,
			user: this.$store.state.user,
			permissions: {
				add: false,
				edit: false,
				delete: false
			}
		}
	},

	created () {
		this.permissions = general.checkPermissions(this.data.entity.privileges, this.user.roles)

		// fetch translations form
		if (!this.translationsForm) {
			var url = '/cms/api/forms?entity=' + this.entityID
			xhrModule.get(url, this.fetchFormCompleted.bind(this))

			this.groupFragments()
		}
	},

	updated () {
		var options = {
			redactorFieldPush: this.redactorFieldPush.bind(this),
			allFieldsPushedCallback: this.redactorCallback.bind(this)
		}

		redactorConfig.init(options)

		// format languages
		cms.setLanguagesDimensions(this.$refs.langswitch.languages)
	},

	mounted () {
		this.editTranslationsWrapper = this.$el.querySelector('.edit-translations')
		this.addTranslationsWrapper = this.$el.querySelector('.add-translations')
		this.addCloseToggleBtn = document.querySelector('.btn-add.fa-plus')
		this.formAddTranslations = this.$el.querySelector('#add-translation')
		this.sidebarInner = document.querySelector('.sidebar .inner')
		this.checkboxes = this.$el.querySelectorAll('input[type=checkbox]')
	},

	destroyed () {
		redactorConfig.destroy()
		for (var i = this.redactorFields.length - 1; i >= 0; i--) {
			this.redactorFields[i].removeEventListener('focus', this.translationFocusHandler)
			this.redactorFields[i].removeEventListener('blur', this.translationBlurHandler)
			this.redactorFields.splice(i, 1)
		}
	},

	methods: {
		groupFragments () {
			this.fragments = null
			var fragments = this.data.fragments

			// group them by uuid
			var fragGroups = {}
			for (var frag in fragments) {
				// when there are no templates we can skip them
				if (!fragments[frag].templates) continue
				if (fragments[frag].templates.includes(this.data.template)) {
					var uuid = fragments[frag].uuid
					if (!fragGroups[uuid]) fragGroups[uuid] = {}
					fragGroups[uuid][fragments[frag].market.locale] = fragments[frag]
				}
			}

			setTimeout(function () {
				this.fragments = fragGroups
			}.bind(this), 200)
		},

		fetchFormCompleted (form) {
			this.translationsForm = form.data[Object.keys(form.data)[0]]
		},

		machineNameChangeHandler (e) {
			var value = e.currentTarget.value
			this.machineName = general.convertToSlug(value)
		},

		addItem () {
			if (!this.overlayHidden) {
				this.editTranslationsWrapper.classList.remove('hidden')
				this.addTranslationsWrapper.classList.add('hidden')
				this.addCloseToggleBtn.classList.replace('btn-close', 'btn-add')
				this.addCloseToggleBtn.classList.replace('fa-times', 'fa-plus')
				this.overlayHidden = true
			} else {
				this.editTranslationsWrapper.classList.add('hidden')
				this.addTranslationsWrapper.classList.remove('hidden')
				this.addCloseToggleBtn.classList.replace('btn-add', 'btn-close')
				this.addCloseToggleBtn.classList.replace('fa-plus', 'fa-times')
				this.overlayHidden = false

				// create a new UUID
				this.uuid = null
				var url = '/cms/api/uuid'
				xhrModule.get(url, this.fetchedUUIDComplete.bind(this))
			}
		},

		save () {
			// ignore clicks on the save button when we are saving
			if (this.posting) return

			if (this.overlayHidden) {
				// close sidebar
				this.$parent.toggle()
			} else {
				// we must have a uuid first
				if (!this.uuid) return

				// validate input
				var valid = validation.validate(this.formAddTranslations)
				if (!valid) return

				// create new translation and close overlay
				var formData = new FormData(this.formAddTranslations)
				var obj = general.convertFormDataToObject(formData)
				var objArr = []

				// post this for each language
				this.saveCallbackInt = 0
				this.instancesLength = Object.keys(this.data.languages).length
				var int = 0
				for (var lang in this.data.languages) {
					int++

					// format the editoroptions into a string when there are multiple options selected
					var options = '["' + obj.options + '"]'
					if (Array.isArray(obj.options)) {
						options = JSON.stringify(obj.options)
					}
					if (!obj.options) options = '[]'

					var finalObj = {
						id: 0,
						data: {
							0: {
								id: 0,
								property: {
									id: this.translationsForm.entity.properties.name.id,
									name: this.translationsForm.entity.properties.name.name
								},
								value: obj.name
							},
							1: {
								id: 0,
								property: {
									id: this.translationsForm.entity.properties.translation.id,
									name: this.translationsForm.entity.properties.translation.name
								},
								value: ''
							}
						},
						settings: {
							editoroptions: {
								id: 0,
								name: 'editoroptions',
								value: options
							}
						},
						entity: {
							id: this.translationsForm.entity.id,
							name: this.translationsForm.entity.name
						},
						market: {
							id: this.data.languages[lang].id,
							locale: this.data.languages[lang].locale
						},
						state: 3,
						uuid: this.uuid
					}

					objArr.push(finalObj)

					if (int === this.instancesLength) {
						this.postInstances(objArr)
					}
				}
			}
		},

		deleteTranslatationClickHandler (e) {
			e.preventDefault()

			var uuid = e.currentTarget.getAttribute('data-uuid')
			var fragsToDelete = this.fragments[uuid]

			delete this.fragments[uuid]
			this.$forceUpdate()

			var obj = {
				'entity': null,
				'uuid': null,
				'instance': []
			}

			var totalLength = Object.keys(fragsToDelete).length
			var int = 0
			for (var del in fragsToDelete) {
				int++
				if (!obj.entity) {
					obj.entity = fragsToDelete[del].entity.id
					obj.uuid = fragsToDelete[del].uuid
				}

				obj.instance.push({
					'id': fragsToDelete[del].id,
					'market': fragsToDelete[del].market.id,
					'state': 5
				})

				if (int === totalLength) {
					var json = JSON.stringify(obj)
					var url = '/cms/api/instances/save'
					xhrModule.post(url, json, this.deleteTranslationCompleted.bind(this))
				}
			}
		},

		deleteTranslationCompleted () {
			general.saveAnimation()
		},

		translationFocusHandler (e) {
			e.preventDefault()

			var target = e.currentTarget.parentNode.querySelector('textarea')
			var value = target.value

			var arr = {
				target: target,
				value: value
			}

			this.changedFieldsArr.push(arr)
		},

		translationBlurHandler (e) {
			e.preventDefault()

			var target = e.currentTarget.parentNode.querySelector('textarea')

			// set a delay for the blur event so our value has the time to be added to the changed fields array before the blur event gets called
			setTimeout(function () {
				// find target in changedFieldsArr and check if the field has been changed or not
				for (var i = this.changedFieldsArr.length - 1; i >= 0; i--) {
					if (this.changedFieldsArr[i].target === target) {
						if (this.changedFieldsArr[i].value !== target.value) {
							this.gatherDataToSave(target)
							this.changedFieldsArr.splice(i, 1)
						} else {
							this.changedFieldsArr.splice(i, 1)
						}
					}
				}
			}.bind(this), 500)
		},

		gatherDataToSave (target) {
			// gather data
			var uuid = target.getAttribute('data-uuid')
			var lang = target.getAttribute('data-lang')

			// change value
			this.fragments[uuid][lang].data.translation.value = target.value
			this.postInstancesTranslations(this.fragments[uuid][lang])
		},

		fetchedUUIDComplete (uuid) {
			this.uuid = uuid.data
		},

		postInstances (instances) {
			this.posting = true
			this.sidebarInner.classList.add('loading')

			var obj = {
				'entity': null,
				'uuid': null,
				'instance': []
			}

			for (var i = instances.length - 1; i >= 0; i--) {
				if (!obj.entity) {
					obj.entity = instances[i].entity.id
					obj.uuid = instances[i].uuid
				}

				var instance = {
					'id': instances[i].id,
					'market': instances[i].market.id,
					'state': 3,
					'properties': [],
					'settings': []
				}

				obj.instance.push(instance)

				for (var key in instances[i].data) {
					instance.properties.push({
						'id': instances[i].data[key].id,
						'property': instances[i].data[key].property.id,
						'value': instances[i].data[key].value
					})
				}

				for (var setting in instances[i].settings) {
					instance.settings.push({
						'id': instances[i].settings[setting].id,
						'name': instances[i].settings[setting].name,
						'value': instances[i].settings[setting].value
					})
				}

				if (i === 0) {
					var jsondata = JSON.stringify(obj)
					var url = '/cms/api/instances/save'
					xhrModule.post(url, jsondata, this.postInstanceCompleteHandler.bind(this))
				}
			}
		},

		postInstancesTranslations (instance) {
			// convert data to post
			var obj = {
				'entity': instance.entity.id,
				'uuid': instance.uuid,
				'instance': []
			}

			var instanceEl = {
				'id': instance.id,
				'market': instance.market.id,
				'state': instance.state,
				'properties': [],
				'settings': []
			}

			for (var prop in instance.data) {
				instanceEl.properties.push({
					'id': instance.data[prop].id,
					'property': instance.data[prop].property.id,
					'value': instance.data[prop].value
				})
			}

			for (var setting in instance.settings) {
				instanceEl.settings.push({
					'id': instance.settings[setting].id,
					'name': instance.settings[setting].name,
					'value': instance.settings[setting].value
				})
			}

			obj.instance.push(instanceEl)

			var jsondata = JSON.stringify(obj)
			var url = '/cms/api/instances/save'
			xhrModule.post(url, jsondata, this.postInstanceTranslationCompleteHandler.bind(this))
		},

		postInstanceTranslationCompleteHandler () {
			general.saveAnimation()
		},

		postInstanceCompleteHandler () {
			this.sidebarInner.classList.remove('loading')
			this.addItem()
			this.posting = false
			// this.fetchFragments()
			general.saveAnimation()

			// reset form
			this.machineName = null
			for (var i = this.checkboxes.length - 1; i >= 0; i--) {
				this.checkboxes[i].checked = false
				this.checkboxes[i].parentNode.classList.remove('checked')
				this.checkboxes[i].parentNode.parentNode.parentNode.classList.remove('checked')
			}
		},

		redactorFieldPush (field) {
			this.redactorFields.push(field)
		},

		redactorCallback (fields) {
			for (var i = this.redactorFields.length - 1; i >= 0; i--) {
				this.redactorFields[i].addEventListener('focus', this.translationFocusHandler)
				this.redactorFields[i].addEventListener('blur', this.translationBlurHandler)
			}
		}
	}
}

</script>
